import { shortenNumber } from '@ydistri/generic-utils';
import { StatisticItem } from '../StatisticsSummary';
import { CalculationStatisticStoreTargetResponse } from '@ydistri/api-sdk';

export const buildTargetStoreStats = (
  targetStores: CalculationStatisticStoreTargetResponse[] | undefined | null,
  hasDepartments: boolean,
  currency: string,
): StatisticItem[] => {
  const totalValue = targetStores?.reduce((sum, r) => sum + r.value, 0) ?? 0;
  const totalQuantity = targetStores?.reduce((sum, r) => sum + r.quantity, 0) ?? 0;
  const totalPickingPositions =
    targetStores?.reduce((sum, r) => sum + r.pickingPositionCount, 0) ?? 0;
  const count = targetStores?.length ?? 0;

  return [
    { title: `Target Store${hasDepartments ? '-Department' : ''}s`, value: count },
    { title: 'Picking Positions', value: shortenNumber(totalPickingPositions) },
    { title: `Value (${currency})`, value: shortenNumber(totalValue) },
    { title: 'Quantity', value: shortenNumber(totalQuantity) },
  ];
};
